import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GrowlerService } from '../../../../services/growler.service';
import { PaymentGroup } from 'app/models/entities/payment-group';
import { PaymentGroupsService } from 'app/services/payment/payment-groups.service';

export interface DeleteOfflinePaymentDialogInput
{
    paymentGroups: PaymentGroup[];
}

export interface DeleteOfflinePaymentDialogResult
{
    success: boolean;
}

@Component({
    selector: 'app-delete-offline-payment-dialog',
    templateUrl: './delete-offline-payment-dialog.component.html',
})
export class DeleteOfflinePaymentDialogComponent
{
    form: FormGroup = this._formBuilder.group({
        reason: [
            '',
            Validators.required,
        ],
        markReturned: [false],
        deleteFromTransactions: [false],
    });

    constructor(
            private _dialogRef: MatDialogRef<DeleteOfflinePaymentDialogComponent>,
            private _formBuilder: FormBuilder,
            private _growler: GrowlerService,
            private _paymentGroups: PaymentGroupsService,
            @Inject(MAT_DIALOG_DATA) public data: DeleteOfflinePaymentDialogInput,
    ) {
    }

    get hasLinkedPayments() {
        return this.data.paymentGroups.some(p => p.isLinked);
    }

    closeAndConfirm() {
        if (this.form.invalid) {
            this._growler.error('Missing Reason', 'The reason is a required field.');
            return;
        }

        this._paymentGroups
                .deleteOfflinePaymentGroups(
                        null,
                        this.data.paymentGroups.map(p => p.id),
                        this.form.get('reason').value,
                        this.form.get('markReturned').value,
                        this.form.get('deleteFromTransactions').value,
                )
                .subscribe(() => {

                    this._growler.success(
                            'Success',
                            'Payment successfully deleted.',
                    );
                    this._dialogRef.close(<DeleteOfflinePaymentDialogResult>{
                        success: true,
                    });
                }, () => {
                    this._growler.error('Error Deleting Payment',
                            'The selected payment could not be deleted.');
                });

    }

}
